import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getToken = () => localStorage.getItem("lau_token");
export const setToken = (t) => (t ? localStorage.setItem("lau_token", t) : localStorage.removeItem("lau_token"));

export const authConfig = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const imgSrc = (url) => (url && url.startsWith("/") ? `${API}${url}` : url);

export const WHATSAPP_NUMBER = "393509374737";
export const waLink = (text) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const SHOWROOM = { address: "Via G. Marconi 22, 20090 Monzoro - Cusago (MI)" };
export const LEGAL = { address: "Via Maffeo Bagarotti 16, 20152 Milano (MI)" };
